import { match } from 'ts-pattern'

import { ConditionPropertyEditorComponent } from 'Automations/nodeDefinitions/conditions'
import { isCustomPropertyOperatorId } from 'Automations/nodeDefinitions/conditions/helpers/functionStrings'
import { CustomerIncludesOperatorEditor } from './CustomerIncludesOperatorEditor'
import { CustomPropertyOperatorEditor } from './CustomPropertyOperatorEditor'
import { NoOperatorEditor } from './NoOperatorEditor'

/**
 * Property-level editor for CUSTOMER. Routes to the operator-specific editor:
 * INCLUDES / EXCLUDES share a customer multi-select; a custom-property operator
 * (`CUSTOM_PROPERTY:<key>`) renders the equals/not-equals + value rows.
 */
export const CustomerPropertyEditor: ConditionPropertyEditorComponent = props =>
  match(props.operator)
    .with('INCLUDES', 'EXCLUDES', () => (
      <CustomerIncludesOperatorEditor {...props} />
    ))
    .when(isCustomPropertyOperatorId, () => (
      <CustomPropertyOperatorEditor {...props} />
    ))
    .otherwise(() => <NoOperatorEditor {...props} />)
